(function (window) {
  /**
   * A utility component that manages the BatchGeoVerticalResizer instance for
   * both the data element and table because they require identical logic.
   * This component allows us to keep the code a bit more DRY and not
   * accidentally lose logic if you edit one and not the other. It also allows
   * for easier testing of the callback handlers.
   *
   * @param {object} options The options hash
   * @param {jQuery|HTMLElement|string} options.container The selector (or
   * element or jQuery object) of the element you want to attach to. The logic
   * is very opinionated as it is assuming its either the data list or the
   * table view though.
   */
  var BatchGeoDataAndTableResizer = function (options) {
    this.settings = $.extend(
      true,
      {
        container: null,
      },
      options,
    );

    this.$elements = {
      mapWrap: $("#mapWrap"),
      mapDiv: $("#mapDiv"),
      scroller: $(".clusterize-scroll"),
    };

    this.verticalResizerInstance = new BatchGeoVerticalResizer({
      container: this.settings.container,
      onStart: this.onStartAndEnd.bind(this),
      onEnd: this.onStartAndEnd.bind(this),
      onResize: this.onResize.bind(this),
    });
  };

  /**
   * The method that is called when the dragging starts or stops. It will
   * track the heights of all elements needed for calculations as you drag.
   */
  BatchGeoDataAndTableResizer.prototype.onStartAndEnd = function () {
    BatchGeoStore.dispatch({
      type: "TABLE_MAP_UPDATE_HEIGHTS",
      mapHeights: {
        mapWrap: this.$elements.mapWrap.height(),
        mapDiv: this.$elements.mapDiv.height(),
        tableScroller: this.$elements.scroller.height(),
      },
    });
  };

  /**
   * The method that is fired while the user is actively resizing. It manages
   * updating the heights of all elements dynamically as well as caching it in
   * localStorage so it's available on page load.
   *
   * @param {object} event A BatchGeoVerticalResizer event object. It expects
   * a `height` key to be passed to it.
   */
  BatchGeoDataAndTableResizer.prototype.onResize = function (event) {
    var startHeights = BatchGeoStore.getState().BatchGeoTableMap.mapHeights;
    var heights = {
      mapWrap: startHeights.mapWrap - event.height,
      mapDiv: startHeights.mapDiv - event.height,
      scroller: startHeights.tableScroller + event.height,
    };

    var $topBar = $("#topBar");
    var $legWrap = $("#legWrap");

    // Prevent the table from making the map 0px tall which would put the
    // resizer bar under the header bar or the browser URL bar making it
    // impossible to ever size back smaller.
    if (heights.mapDiv < 1) return;

    var tableSizingPersist = new BatchGeoPersistence({ key: "TableSizing" });
    tableSizingPersist.set(heights);

    this.$elements.mapWrap.height(heights.mapWrap);
    this.$elements.scroller.height(heights.scroller);

    if (heights.mapDiv < 200 || $legWrap.text().trim().length === 0) {
      if ($legWrap.is(":visible")) {
        $legWrap.toggle();
      }
    } else {
      if (!$legWrap.is(":visible")) {
        $legWrap.toggle();
      }
    }

    var legWrapHeight = $legWrap.is(":visible") ? $legWrap.outerHeight() : 0;
    var topBarHeight = $topBar.is(":visible") ? $topBar.outerHeight() : 0;

    // This height needs to be dynamically set because the legend
    // height changes
    this.$elements.mapDiv.height(
      heights.mapWrap - legWrapHeight - topBarHeight,
    );

    // Google needs to know that the container was resized to fill in the map
    google.maps.event.trigger(
      window.batchGeoGoogleMapsManager.getMap(),
      "resize",
    );
  };

  window.BatchGeoDataAndTableResizer = BatchGeoDataAndTableResizer;
})(window);
